import { DocumentNode, gql } from '@apollo/client';
import { Button, ButtonProps, useDisclosure } from '@chakra-ui/react';
import * as React from 'react';

import { LogInSignUpModal } from '@/components/LogInSignUp';
import { PaywallModal } from '@/components/Paywall';
import { useSponsorPaywallModal } from '@/components/Post/hooks/useSponsorPaywallModal';
import { useShowPostResponses } from '@/hooks/useShowPostResponses';

import { AnswerButton_QuestionFragment } from './graphql-types/AnswerButton_QuestionFragment';

import { CreateAnswerModal } from './components/CreateAnswerModal';

export const AnswerButton: React.FC<
  {
    question: AnswerButton_QuestionFragment;
  } & ButtonProps
> & {
  questionFragment: DocumentNode;
} = ({ question, ...buttonProps }) => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  const sponsorPaywallModalProps = useSponsorPaywallModal(question);

  const {
    showPostResponses,
    behaviorOverride,
    paywallDisclosure,
    loginDisclosure,
  } = useShowPostResponses(question);

  return (
    <>
      <Button
        {...buttonProps}
        onClick={behaviorOverride ? behaviorOverride : onOpen}
        isDisabled={!showPostResponses}
      >
        Answer
      </Button>
      <CreateAnswerModal
        isOpen={isOpen}
        onClose={onClose}
        question={question}
      />
      <PaywallModal
        isOpen={paywallDisclosure.isOpen}
        onClose={paywallDisclosure.onClose}
        source="respond to post paywall"
        {...sponsorPaywallModalProps}
      />
      <LogInSignUpModal
        isOpen={loginDisclosure.isOpen}
        onClose={loginDisclosure.onClose}
      />
    </>
  );
};
AnswerButton.questionFragment = gql`
  fragment AnswerButton_QuestionFragment on QuestionV2 {
    _id
    ...CreateAnswerModal_QuestionFragment
    ...useShowPostResponses_PostFragment
    ...useSponsorPaywallModal_PostFragment
  }
  ${CreateAnswerModal.questionFragment}
  ${useShowPostResponses.postFragment}
  ${useSponsorPaywallModal.postFragment}
`;
